import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Box, Button, Card } from "@mui/material";
import { KitModal } from "./kit-modal.component";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const containerPadding = 40;
const sliderContainerPadding = 16;
const imageWidthDesktop = 153;
const imageHeightDesktop = 163;
const imageSeparationDesktop = 15;
const imageWidthMobile = 91;
const imageSeparationMobile = 10;

export function Slider({ images, modalLabel = "", downloadText }) {
  const cardRef = useRef(null);
  const [imagesToShow, setImagesToShow] = useState([]);
  const [imagesToHide, setImagesToHide] = useState([]);
  const [showModalHiddenImages, setShowModalHiddenImages] = useState(false);
  const [modalCurrentImageIndex, setModalCurrentImageIndex] = useState(0);
  const [pages, setPages] = useState([1, 2, 3, 4, 5]);

  const handleDownloadImg = (img) => {
    const enlace = document.createElement("a");
    enlace.href = img.url;
    enlace.download = img.filename;
    document.body.appendChild(enlace);
    enlace.click();
    document.body.removeChild(enlace);
  };

  const handleSliderImages = (currentWidth) => {
    const width = currentWidth - sliderContainerPadding;
    const imagesWidth =
      currentWidth + containerPadding > 500
        ? imageWidthDesktop + imageSeparationDesktop
        : imageWidthMobile + imageSeparationMobile;
    const imagesToShowNum = Math.floor(width / imagesWidth);
    if (images.length > imagesToShowNum) {
      const newArrayToShow = images.slice(0, imagesToShowNum - 1);
      const newArrayToHide = images.slice(imagesToShowNum - 1);
      setImagesToShow(newArrayToShow);
      setImagesToHide(newArrayToHide);
      setModalCurrentImageIndex(0);
    } else {
      setImagesToShow(images);
      setImagesToHide([]);
      setModalCurrentImageIndex(0);
      setShowModalHiddenImages(false);
    }
  };

  useEffect(() => {
    const updateCardSize = () => {
      if (cardRef.current) {
        const width = cardRef.current.clientWidth;
        handleSliderImages(width);
      }
    };
    updateCardSize();
    window.addEventListener("resize", updateCardSize);
    return () => {
      window.removeEventListener("resize", updateCardSize);
    };
  }, []);

  const ResourceImage = ({ item, i }) => (
    <VuiBox
      onClick={() => {
        setModalCurrentImageIndex(i);
        setShowModalHiddenImages(true);
      }}
      component="img"
      src={item.url}
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "15px",
      }}
    />
  );

  const ResourceCard = ({ item, i }) => (
    <VuiBox
      onClick={() => {
        setModalCurrentImageIndex(i);
        setShowModalHiddenImages(true);
      }}
      component="div"
      sx={{
        width: "100%",
        height: "100%",
        borderRadius: "16px",
        backgroundColor: "#0d0d38",
        color: "white !important",
        padding: "15px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "10px",
        border: "1px solid #39444c",
      }}
    >
      <Box
        sx={{
          height: "60px",
          overflowY: "auto",
          scrollbarWidth: "thin",
          scrollbarColor: "#39444c #0e1534",
        }}
      >
        <VuiTypography
          color="white"
          sx={{
            fontWeight: "700",
            fontSize: "15px",
          }}
        >
          {item.filename}
        </VuiTypography>
      </Box>

      <Box>
        <VuiTypography
          color="white"
          sx={{
            fontSize: "13px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {item.url}
        </VuiTypography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", borderTop: "1px solid #39444c", paddingTop: "4px" }}>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleCopy(item.url);
          }}
          sx={{
            color: "gray !important",
          }}
        >
          <ContentCopyIcon
            sx={{
              margin: "0 5px",
              scale: "1.2",
            }}
          />
        </Button>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleOpen(item.url);
          }}
          sx={{
            color: "gray !important",
          }}
        >
          <OpenInNewIcon
            sx={{
              margin: "0 5px",
              scale: "1.2",
            }}
          />
        </Button>
      </Box>
    </VuiBox>
  );

  const getComponentByType = (type, data) => {
    switch (type) {
      case 1:
        return ResourceImage(data);
      case 2:
        return ResourceCard(data);
      default:
        return Image(data);
    }
  };

  const handleCopy = (url) => {
    navigator.clipboard.writeText(url);
  };

  const handleOpen = (url) => {
    window.open(url, "_blank");
  };

  return (
    <VuiBox>
      <Card
        ref={cardRef}
        sx={{ display: "flex", alignItems: "center", flexDirection: "row", padding: "16px" }}
      >
        {imagesToShow.map((item, i) => (
          <VuiBox
            key={i}
            sx={({ breakpoints }) => ({
              flexGrow: "1",
              flexBasis: "0",
              flexShrink: "0",
              minWidth: `${imageWidthDesktop}px`,
              height: `${imageHeightDesktop}px`,
              marginRight: `${imageSeparationDesktop}px`,
              maxWidth: "200px",
              cursor: "pointer",
              [breakpoints.down(550)]: {
                minWidth: `${imageWidthMobile}px`,
                height: `${imageWidthMobile}px`,
                marginRight: `${imageSeparationMobile}px`,
              },
            })}
          >
            {getComponentByType(item.type, { i, item })}
          </VuiBox>
        ))}
        {imagesToHide.length > 1 && (
          <VuiBox
            onClick={() => {
              setModalCurrentImageIndex(images.length - imagesToHide.length);
              setShowModalHiddenImages(true);
            }}
            sx={({ breakpoints }) => ({
              flexGrow: "1",
              flexBasis: "0",
              flexShrink: "0",
              minWidth: `${imageWidthDesktop}px`,
              height: `${imageHeightDesktop}px`,
              marginLeft: "auto",
              position: "relative",
              [breakpoints.down(550)]: {
                minWidth: `${imageWidthMobile}px`,
                height: `${imageWidthMobile}px`,
              },
            })}
          >
            {getComponentByType(imagesToHide[0].type, { i: 1, item: imagesToHide[0] })}

            <VuiBox
              sx={{
                position: "absolute",
                backgroundColor: "",
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                borderRadius: "15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <VuiTypography
                color="white"
                component="h2"
                sx={{
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                + {imagesToHide.length}
              </VuiTypography>
            </VuiBox>
          </VuiBox>
        )}
        {images.length === 0 && (
          <VuiBox
            sx={{
              width: "200px",
              cursor: "pointer",
            }}
          >
            No hay recursos
          </VuiBox>
        )}
      </Card>
      <KitModal
        actionModal={handleDownloadImg}
        images={images}
        showModalHiddenImages={showModalHiddenImages}
        modalCurrentImageIndex={modalCurrentImageIndex}
        setModalCurrentImageIndex={setModalCurrentImageIndex}
        setShowModalHiddenImages={setShowModalHiddenImages}
        pages={pages}
        setPages={setPages}
        modalLabel={modalLabel}
        downloadText={downloadText}
      ></KitModal>
    </VuiBox>
  );
}
